// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { QbItemDto } from './QbItemDto';
import { EntityBaseDto } from './EntityBaseDto';

// AbilityIntranet.Data.Intranet.TxnTemplateLineDto
export class TxnTemplateLineDto extends EntityBaseDto {
    public lineNumber: number = 0;
    public item: QbItemDto = null;
    public desc: string = null;
    public quantity: number = null;
    public rate: number = null;
    public amount: number = null;
}


    



